<template>
	<div id="main" class="column is-9">
		<ProfileHeader :psychic="psychic" />
		<section class="latest-readings">
			<div class="columns">
				<div class="column">
					<div class="card">
						<header class="card-header">
							<p class="card-header-title">
								Customers
							</p>
						</header>
						<div class="column">
							<div class="columns refine">
								<DatePicker 
									:startDate="startDate" 
									:endDate="endDate"
									@startDateInput="updateStartDate"
									@endDateInput="updateEndDate"
									@enter="updateData" />
								<div class="column is-7">
									<div class="columns refine is-mobile">
										<div class="column">
											<div class="field">
												<div class="control">
													<a class="button is-primary is-small" @click="updateData">
													Update </a>
												</div>
											</div>
										</div>
									<div class="column">
										<PageSize v-model="pageSize" @input="$refs.paginator.goToPage(0)" />
									</div>
									</div>
								</div>
							</div>
						</div>
						<div class="card-table">
							<div class="content">
								<table id="allPsychics" class="table is-narrow is-fullwidth is-striped">
									<thead>
										<tr>
											<th>
												<a @click="sortCustomers('userName')">Member</a>
											</th>
											<th>
												<a @click="sortCustomers('lastReading')">Last Reading</a>
											</th>
											<th>
												<a @click="sortCustomers('readings')">Readings</a>
											</th>
											<th>
												<a @click="sortCustomers('totalMinutes')">Call Length</a>
											</th>
											<th>
												<a @click="sortCustomers('freeMins')"><span class="is-hidden-mobile">Unused Free Min.</span></a>
											</th>
											<th>
												<a @click="sortCustomers('alc')">ALC</a>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(customer, idx) in paginatedData" :key="idx">
											<td class="member-name"><a @click="showCustomerDetail(customer)">{{ customer.userName }}</a></td>
											<td class="break-it">{{ formatReadingDate(customer.lastReading) }}</td>
											<td class="">{{ customer.readings }}</td>
											<td class="">{{ customer.totalMinutes }}</td>
											<td class="">{{ customer.freeMins }}</td>
											<td class="">{{ customer.alc }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Paginator ref="paginator" :itemCount="customers.length" :pageSize="pageSize" v-model="pageNumber" />
		</section>
		<Modal v-if="customerDetailShown" @close="customerDetailShown = false">
			<span slot="title">READING DETAILS FOR {{ selectedCustomer.userName }}</span>
			<div class="columns" slot="body">
				<div class="column">
					<div class="card">
						<div class="card-table">
							<div class="content">
								<table class="table is-fullwidth is-striped">
									<thead>
										<tr>
											<th>
												<a @click="sortCustomerDetail('date')">Date/Time</a>
											</th>
											<th>
												<a @click="sortCustomerDetail('minutes')">Minutes</a>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(detail, idx) in sortedCustomerDetail" :key="idx">
											<td>
												{{ formatReadingDate(detail.date) }}
											</td>
											<td>
												{{ detail.minutes }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import ProfileHeader from "./ProfileHeader.vue"
	import DatePicker from "../DatePicker.vue"
	import PageSize from "../PageSize.vue"
	import Paginator from "../Paginator.vue"
	import Modal from "../Modal.vue"
	import moment from "moment-timezone"

	export default {
		components: {
			Paginator,
			ProfileHeader,
			DatePicker,
			PageSize,
			Modal
		},
		data() {
			return {
				pageSize: 10,
				pageNumber: 0,
				customers: [],
				psychic: {},
				selectedCustomer: {},
				customerDetail: [],
				customerDetailShown: false,
				customerDetailSortDir: -1,
				customerDetailSortCol: "date",
				customerSortDir: -1,
				customerSortCol: "lastReading",
				startDate: moment(Date.now()).add(-7, 'days').valueOf().toString(),
				endDate: Date.now().toString(),
			}
		},
		methods: {
			formatReadingDate(date) {
				return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY")
			},
			async showCustomerDetail(customer) {
				this.customerDetail = await this.$root.$data.getters.getCustomerDetail(this.$root.$data.state, this.$route.params["id"], customer.ID)
				this.selectedCustomer = customer
				this.customerDetailShown = true
				this.customerDetailSortCol = "date"
				this.customerDetailSortDir = -1
			},
			sortCustomers(col) {
				if (col === this.customerSortCol) {
					this.customerSortDir = this.customerSortDir === -1 ? 1 : -1
				} else {
					this.customerSortCol = col
					this.customerSortDir = -1
				}
			},
			sortCustomerDetail(col) {
				if (col === this.customerDetailSortCol) {
					this.customerDetailSortDir = this.customerDetailSortDir === -1 ? 1 : -1
				} else {
					this.customerDetailSortCol = col
					this.customerDetailSortDir = -1
				}
			},
			updateStartDate(date) {
				this.startDate = moment(date).valueOf().toString()
			},
			updateEndDate(date) {
				this.endDate = moment(date).valueOf().toString()
			},
			async updateData() {
				this.customers = await this.$root.$data.getters.getCustomers(this.$root.$data.state, this.$route.params["id"], this.startDate, this.endDate)
			},
		},
		computed: {
			paginatedData() {
				const start = this.pageNumber * this.pageSize,
					end = start + this.pageSize

				return this.sortedCustomers.slice(start, end)
			},
			sortedCustomers() {
				let sorted = this.customers
				return sorted.sort((a, b) => {
					if (a[this.customerSortCol] < b[this.customerSortCol]) return -1 * this.customerSortDir
					if (a[this.customerSortCol] > b[this.customerSortCol]) return 1 * this.customerSortDir
					return 0
				})
			},
			sortedCustomerDetail() {
				let sorted = this.customerDetail
				return sorted.sort((a, b) => {
					if (a[this.customerDetailSortCol] < b[this.customerDetailSortCol]) return -1 * this.customerDetailSortDir
					if (a[this.customerDetailSortCol] > b[this.customerDetailSortCol]) return 1 * this.customerDetailSortDir
					return 0
				})
			}
		},
		async created() {
			const [psychicResp, customersResp] = await Promise.all([
				this.$root.$data.getters.getPsychic(this.$root.$data.state, this.$route.params["id"]), 
				this.$root.$data.getters.getCustomers(this.$root.$data.state, this.$route.params["id"])
			])

			this.psychic = psychicResp
			this.customers = customersResp
		}
	}
</script>